'use client';
import { useState, useEffect } from 'react';
import { seo } from '@/utils/seo';
import { postContact } from '@/utils/contact_service';
import safeWindow from '@/utils/safeWindow';
import { useTranslation } from '@/contexts/TranslationContext';
const ContactForm = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    name: '',
    email: '',
    description: '',
  });

  const [contactSent, setContactSent] = useState(false);

  useEffect(() => {
    seo(safeWindow.location.pathname);
  }, []);

  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    setForm({
      ...form,
      [name]: value,
    });
  };

  const submitForm = () => {
    postContact(form).then((res) => {
      if (res.status === 200) {
        setContactSent(true);
      } else {
        alert(t('contact.error'));
      }

      setForm({
        name: '',
        email: '',
        description: '',
      });
    });
  };

  return (
    <form className="contact-form mt-3" name="ContactForm">
      <h2>{t('contact.heading')}</h2>
      {contactSent && (
        <div flex>
          <span className="text-success text-center">{t('contact.success')}</span>
        </div>
      )}

      <div>
        <input
          name="name"
          placeholder={t('contact.namePlaceholder')}
          type="text"
          onChange={handleInputChange}
          value={form.name}
          required
        />
      </div>

      <div>
        <input
          name="email"
          placeholder={t('contact.emailPlaceholder')}
          type="email"
          onChange={handleInputChange}
          value={form.email}
          required
        />
      </div>

      <div>
        <textarea
          name="description"
          placeholder={t('contact.messagePlaceholder')}
          rows="3"
          onChange={handleInputChange}
          value={form.description}
          required
        />
      </div>

      <div>
        <button type="button" className="btn btn-primary send-message py-2" onClick={submitForm}>
          {t('contact.submit')}
        </button>
      </div>
    </form>
  );
};

export default ContactForm;
